module.exports = __webpack_public_path__ + "static/2023_06_13_QE_091_20_9001_rev01_S2_EC-9217919cc7f7682c8020c8a8ab0a0aa7.pdf";